import { FiShield } from 'react-icons/fi';
import './FemaRegionPrototypeSection.css';

function finiteNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function formatCurrency(value) {
  const number = finiteNumber(value);
  if (number == null) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(number);
}

function barWidth(value) {
  const number = finiteNumber(value);
  return number == null ? '0%' : `${Math.max(2, Math.min(100, number * 100))}%`;
}

function SourceLink({ payload }) {
  return (
    <a
      className="fema-region-demo__source-link"
      href={payload?.source?.documentation_url || payload?.source?.source_url || payload?.release?.service_url}
      target="_blank"
      rel="noreferrer"
    >
      <FiShield aria-hidden="true" /> FEMA NRI docs
    </a>
  );
}

function HazardRows({ hazards, startIndex = 0 }) {
  return (
    <div className="fema-region-demo__hazard-rank">
      {hazards.map((hazard, index) => (
        <div key={hazard.key}>
          <b>{startIndex + index + 1}</b>
          <span>
            <strong>{hazard.label}</strong>
          </span>
          <div><i style={{ width: barWidth(hazard.loss_share) }} /></div>
          <strong>{formatCurrency(hazard.expected_annual_loss)}</strong>
        </div>
      ))}
    </div>
  );
}

export default function FemaRegionPrototypeSection({ loading, error, payload }) {
  if (loading) return <section className="research-detail-card fema-region-demo__state">Loading FEMA region evidence…</section>;
  if (error || !payload) return <section className="research-detail-card fema-region-demo__state">{error || 'FEMA region evidence is unavailable.'}</section>;

  const hazards = (payload.hazards || []).filter((hazard) => hazard.expected_annual_loss > 0);
  const topHazards = hazards.slice(0, 6);
  const otherHazards = (payload.hazards || []).slice(6);

  return (
    <section className="fema-region-prototypes" aria-labelledby="fema-region-prototypes-title">
      <article className="research-detail-card fema-region-demo">
        <header className="fema-region-demo__header"><div><span>Alternative 3</span><h2 id="fema-region-prototypes-title">Which hazards could impact an investment most?</h2></div></header>
        <HazardRows hazards={topHazards} />
        {otherHazards.length ? (
          <details className="fema-region-demo__all-hazards">
            <summary>View all {payload.hazards.length} FEMA hazards</summary>
            <HazardRows hazards={otherHazards} startIndex={6} />
          </details>
        ) : null}
        <p className="fema-region-demo__note">Ranked by summed FEMA modeled annual loss across the market’s governed counties; hazard scores are not added together. <SourceLink payload={payload} /></p>
      </article>
    </section>
  );
}
